/**
 * Per-model field-renderer overrides registered by SourcePilot.
 *
 * Importing this module registers the overrides on the framework's
 * Jotai store. `ModelDetailView` then picks them up via
 * `useFieldOverrides(model)` anywhere in the route tree — no Provider
 * needed, so it works for routes outside `(main)/` too.
 *
 * Add an entry when the generic Zod-driven editor can't see enough to
 * pick the right input shape (most often: a polymorphic value field
 * whose type is constrained by a sibling relationship, not its own
 * Pydantic / Zod type).
 */

import { setFieldOverrides } from "@sourcepilot/ui/framework/ui/views";
import { AttributeValueValueEditor } from "@/ui/molecules/attribute-value-value-editor";
import { AnalysisRecordCompleteness, AnalysisRecordIncompleteDetail } from "@/ui/molecules/analysis-record-completeness";

setFieldOverrides({
  AttributeValue: {
    // `value` is typed `Any` because its runtime type (number / string /
    // bool / list) depends on the linked Attribute's class+shape.
    // See molecules/attribute-value-value-editor for the dispatch.
    value: AttributeValueValueEditor as any,
  },
  AnalysisRecord: {
    // a check that could not see everything reads "Incomplete: <missing>",
    // never passed (vc-impl a05ef33f8); read-only, the server writes it
    complete: AnalysisRecordCompleteness as any,
    incomplete_json: AnalysisRecordIncompleteDetail as any,
  },
});
